/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import {
  Signer,
  utils,
  BigNumberish,
  Contract,
  ContractFactory,
  Overrides,
} from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  NativeOrdersFeature,
  NativeOrdersFeatureInterface,
} from "../NativeOrdersFeature";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "zeroExAddress",
        type: "address",
      },
      {
        internalType: "contract IEtherTokenV06",
        name: "weth",
        type: "address",
      },
      {
        internalType: "contract IStaking",
        name: "staking",
        type: "address",
      },
      {
        internalType: "contract FeeCollectorController",
        name: "feeCollectorController",
        type: "address",
      },
      {
        internalType: "uint32",
        name: "protocolFeeMultiplier",
        type: "uint32",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bytes32",
        name: "orderHash",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "address",
        name: "maker",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "taker",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "feeRecipient",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "makerToken",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "takerToken",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint128",
        name: "takerTokenFilledAmount",
        type: "uint128",
      },
      {
        indexed: false,
        internalType: "uint128",
        name: "makerTokenFilledAmount",
        type: "uint128",
      },
      {
        indexed: false,
        internalType: "uint128",
        name: "takerTokenFeeFilledAmount",
        type: "uint128",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "protocolFeePaid",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "bytes32",
        name: "pool",
        type: "bytes32",
      },
    ],
    name: "LimitOrderFilled",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bytes32",
        name: "orderHash",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "address",
        name: "maker",
        type: "address",
      },
    ],
    name: "OrderCancelled",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "maker",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "signer",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "allowed",
        type: "bool",
      },
    ],
    name: "OrderSignerRegistered",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "maker",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "makerToken",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "takerToken",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "minValidSalt",
        type: "uint256",
      },
    ],
    name: "PairCancelledLimitOrders",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "maker",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "makerToken",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "takerToken",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "minValidSalt",
        type: "uint256",
      },
    ],
    name: "PairCancelledRfqOrders",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bytes32",
        name: "orderHash",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "address",
        name: "maker",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "taker",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "makerToken",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "takerToken",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint128",
        name: "takerTokenFilledAmount",
        type: "uint128",
      },
      {
        indexed: false,
        internalType: "uint128",
        name: "makerTokenFilledAmount",
        type: "uint128",
      },
      {
        indexed: false,
        internalType: "bytes32",
        name: "pool",
        type: "bytes32",
      },
    ],
    name: "RfqOrderFilled",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "origin",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address[]",
        name: "addrs",
        type: "address[]",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "allowed",
        type: "bool",
      },
    ],
    name: "RfqOrderOriginsAllowed",
    type: "event",
  },
  {
    inputs: [],
    name: "EIP712_DOMAIN_SEPARATOR",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "FEATURE_NAME",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "FEATURE_VERSION",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "PROTOCOL_FEE_MULTIPLIER",
    outputs: [
      {
        internalType: "uint32",
        name: "",
        type: "uint32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "contract IERC20TokenV06",
            name: "makerToken",
            type: "address",
          },
          {
            internalType: "contract IERC20TokenV06",
            name: "takerToken",
            type: "address",
          },
          {
            internalType: "uint128",
            name: "makerAmount",
            type: "uint128",
          },
          {
            internalType: "uint128",
            name: "takerAmount",
            type: "uint128",
          },
          {
            internalType: "uint128",
            name: "takerTokenFeeAmount",
            type: "uint128",
          },
          {
            internalType: "address",
            name: "maker",
            type: "address",
          },
          {
            internalType: "address",
            name: "taker",
            type: "address",
          },
          {
            internalType: "address",
            name: "sender",
            type: "address",
          },
          {
            internalType: "address",
            name: "feeRecipient",
            type: "address",
          },
          {
            internalType: "bytes32",
            name: "pool",
            type: "bytes32",
          },
          {
            internalType: "uint64",
            name: "expiry",
            type: "uint64",
          },
          {
            internalType: "uint256",
            name: "salt",
            type: "uint256",
          },
        ],
        internalType: "struct LibNativeOrder.LimitOrder",
        name: "order",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "enum LibSignature.SignatureType",
            name: "signatureType",
            type: "uint8",
          },
          {
            internalType: "uint8",
            name: "v",
            type: "uint8",
          },
          {
            internalType: "bytes32",
            name: "r",
            type: "bytes32",
          },
          {
            internalType: "bytes32",
            name: "s",
            type: "bytes32",
          },
        ],
        internalType: "struct LibSignature.Signature",
        name: "signature",
        type: "tuple",
      },
      {
        internalType: "uint128",
        name: "takerTokenFillAmount",
        type: "uint128",
      },
      {
        internalType: "address",
        name: "taker",
        type: "address",
      },
      {
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "_fillLimitOrder",
    outputs: [
      {
        internalType: "uint128",
        name: "takerTokenFilledAmount",
        type: "uint128",
      },
      {
        internalType: "uint128",
        name: "makerTokenFilledAmount",
        type: "uint128",
      },
    ],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "contract IERC20TokenV06",
            name: "makerToken",
            type: "address",
          },
          {
            internalType: "contract IERC20TokenV06",
            name: "takerToken",
            type: "address",
          },
          {
            internalType: "uint128",
            name: "makerAmount",
            type: "uint128",
          },
          {
            internalType: "uint128",
            name: "takerAmount",
            type: "uint128",
          },
          {
            internalType: "address",
            name: "maker",
            type: "address",
          },
          {
            internalType: "address",
            name: "taker",
            type: "address",
          },
          {
            internalType: "address",
            name: "txOrigin",
            type: "address",
          },
          {
            internalType: "bytes32",
            name: "pool",
            type: "bytes32",
          },
          {
            internalType: "uint64",
            name: "expiry",
            type: "uint64",
          },
          {
            internalType: "uint256",
            name: "salt",
            type: "uint256",
          },
        ],
        internalType: "struct LibNativeOrder.RfqOrder",
        name: "order",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "enum LibSignature.SignatureType",
            name: "signatureType",
            type: "uint8",
          },
          {
            internalType: "uint8",
            name: "v",
            type: "uint8",
          },
          {
            internalType: "bytes32",
            name: "r",
            type: "bytes32",
          },
          {
            internalType: "bytes32",
            name: "s",
            type: "bytes32",
          },
        ],
        internalType: "struct LibSignature.Signature",
        name: "signature",
        type: "tuple",
      },
      {
        internalType: "uint128",
        name: "takerTokenFillAmount",
        type: "uint128",
      },
      {
        internalType: "address",
        name: "taker",
        type: "address",
      },
      {
        internalType: "bool",
        name: "useSelfBalance",
        type: "bool",
      },
      {
        internalType: "address",
        name: "recipient",
        type: "address",
      },
    ],
    name: "_fillRfqOrder",
    outputs: [
      {
        internalType: "uint128",
        name: "takerTokenFilledAmount",
        type: "uint128",
      },
      {
        internalType: "uint128",
        name: "makerTokenFilledAmount",
        type: "uint128",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "contract IERC20TokenV06",
            name: "makerToken",
            type: "address",
          },
          {
            internalType: "contract IERC20TokenV06",
            name: "takerToken",
            type: "address",
          },
          {
            internalType: "uint128",
            name: "makerAmount",
            type: "uint128",
          },
          {
            internalType: "uint128",
            name: "takerAmount",
            type: "uint128",
          },
          {
            internalType: "uint128",
            name: "takerTokenFeeAmount",
            type: "uint128",
          },
          {
            internalType: "address",
            name: "maker",
            type: "address",
          },
          {
            internalType: "address",
            name: "taker",
            type: "address",
          },
          {
            internalType: "address",
            name: "sender",
            type: "address",
          },
          {
            internalType: "address",
            name: "feeRecipient",
            type: "address",
          },
          {
            internalType: "bytes32",
            name: "pool",
            type: "bytes32",
          },
          {
            internalType: "uint64",
            name: "expiry",
            type: "uint64",
          },
          {
            internalType: "uint256",
            name: "salt",
            type: "uint256",
          },
        ],
        internalType: "struct LibNativeOrder.LimitOrder[]",
        name: "orders",
        type: "tuple[]",
      },
    ],
    name: "batchCancelLimitOrders",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IERC20TokenV06[]",
        name: "makerTokens",
        type: "address[]",
      },
      {
        internalType: "contract IERC20TokenV06[]",
        name: "takerTokens",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "minValidSalts",
        type: "uint256[]",
      },
    ],
    name: "batchCancelPairLimitOrders",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "maker",
        type: "address",
      },
      {
        internalType: "contract IERC20TokenV06[]",
        name: "makerTokens",
        type: "address[]",
      },
      {
        internalType: "contract IERC20TokenV06[]",
        name: "takerTokens",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "minValidSalts",
        type: "uint256[]",
      },
    ],
    name: "batchCancelPairLimitOrdersWithSigner",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IERC20TokenV06[]",
        name: "makerTokens",
        type: "address[]",
      },
      {
        internalType: "contract IERC20TokenV06[]",
        name: "takerTokens",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "minValidSalts",
        type: "uint256[]",
      },
    ],
    name: "batchCancelPairRfqOrders",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "maker",
        type: "address",
      },
      {
        internalType: "contract IERC20TokenV06[]",
        name: "makerTokens",
        type: "address[]",
      },
      {
        internalType: "contract IERC20TokenV06[]",
        name: "takerTokens",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "minValidSalts",
        type: "uint256[]",
      },
    ],
    name: "batchCancelPairRfqOrdersWithSigner",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "contract IERC20TokenV06",
            name: "makerToken",
            type: "address",
          },
          {
            internalType: "contract IERC20TokenV06",
            name: "takerToken",
            type: "address",
          },
          {
            internalType: "uint128",
            name: "makerAmount",
            type: "uint128",
          },
          {
            internalType: "uint128",
            name: "takerAmount",
            type: "uint128",
          },
          {
            internalType: "address",
            name: "maker",
            type: "address",
          },
          {
            internalType: "address",
            name: "taker",
            type: "address",
          },
          {
            internalType: "address",
            name: "txOrigin",
            type: "address",
          },
          {
            internalType: "bytes32",
            name: "pool",
            type: "bytes32",
          },
          {
            internalType: "uint64",
            name: "expiry",
            type: "uint64",
          },
          {
            internalType: "uint256",
            name: "salt",
            type: "uint256",
          },
        ],
        internalType: "struct LibNativeOrder.RfqOrder[]",
        name: "orders",
        type: "tuple[]",
      },
    ],
    name: "batchCancelRfqOrders",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "contract IERC20TokenV06",
            name: "makerToken",
            type: "address",
          },
          {
            internalType: "contract IERC20TokenV06",
            name: "takerToken",
            type: "address",
          },
          {
            internalType: "uint128",
            name: "makerAmount",
            type: "uint128",
          },
          {
            internalType: "uint128",
            name: "takerAmount",
            type: "uint128",
          },
          {
            internalType: "uint128",
            name: "takerTokenFeeAmount",
            type: "uint128",
          },
          {
            internalType: "address",
            name: "maker",
            type: "address",
          },
          {
            internalType: "address",
            name: "taker",
            type: "address",
          },
          {
            internalType: "address",
            name: "sender",
            type: "address",
          },
          {
            internalType: "address",
            name: "feeRecipient",
            type: "address",
          },
          {
            internalType: "bytes32",
            name: "pool",
            type: "bytes32",
          },
          {
            internalType: "uint64",
            name: "expiry",
            type: "uint64",
          },
          {
            internalType: "uint256",
            name: "salt",
            type: "uint256",
          },
        ],
        internalType: "struct LibNativeOrder.LimitOrder[]",
        name: "orders",
        type: "tuple[]",
      },
      {
        components: [
          {
            internalType: "enum LibSignature.SignatureType",
            name: "signatureType",
            type: "uint8",
          },
          {
            internalType: "uint8",
            name: "v",
            type: "uint8",
          },
          {
            internalType: "bytes32",
            name: "r",
            type: "bytes32",
          },
          {
            internalType: "bytes32",
            name: "s",
            type: "bytes32",
          },
        ],
        internalType: "struct LibSignature.Signature[]",
        name: "signatures",
        type: "tuple[]",
      },
    ],
    name: "batchGetLimitOrderRelevantStates",
    outputs: [
      {
        components: [
          {
            internalType: "bytes32",
            name: "orderHash",
            type: "bytes32",
          },
          {
            internalType: "enum LibNativeOrder.OrderStatus",
            name: "status",
            type: "uint8",
          },
          {
            internalType: "uint128",
            name: "takerTokenFilledAmount",
            type: "uint128",
          },
        ],
        internalType: "struct LibNativeOrder.OrderInfo[]",
        name: "orderInfos",
        type: "tuple[]",
      },
      {
        internalType: "uint128[]",
        name: "actualFillableTakerTokenAmounts",
        type: "uint128[]",
      },
      {
        internalType: "bool[]",
        name: "isSignatureValids",
        type: "bool[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "contract IERC20TokenV06",
            name: "makerToken",
            type: "address",
          },
          {
            internalType: "contract IERC20TokenV06",
            name: "takerToken",
            type: "address",
          },
          {
            internalType: "uint128",
            name: "makerAmount",
            type: "uint128",
          },
          {
            internalType: "uint128",
            name: "takerAmount",
            type: "uint128",
          },
          {
            internalType: "address",
            name: "maker",
            type: "address",
          },
          {
            internalType: "address",
            name: "taker",
            type: "address",
          },
          {
            internalType: "address",
            name: "txOrigin",
            type: "address",
          },
          {
            internalType: "bytes32",
            name: "pool",
            type: "bytes32",
          },
          {
            internalType: "uint64",
            name: "expiry",
            type: "uint64",
          },
          {
            internalType: "uint256",
            name: "salt",
            type: "uint256",
          },
        ],
        internalType: "struct LibNativeOrder.RfqOrder[]",
        name: "orders",
        type: "tuple[]",
      },
      {
        components: [
          {
            internalType: "enum LibSignature.SignatureType",
            name: "signatureType",
            type: "uint8",
          },
          {
            internalType: "uint8",
            name: "v",
            type: "uint8",
          },
          {
            internalType: "bytes32",
            name: "r",
            type: "bytes32",
          },
          {
            internalType: "bytes32",
            name: "s",
            type: "bytes32",
          },
        ],
        internalType: "struct LibSignature.Signature[]",
        name: "signatures",
        type: "tuple[]",
      },
    ],
    name: "batchGetRfqOrderRelevantStates",
    outputs: [
      {
        components: [
          {
            internalType: "bytes32",
            name: "orderHash",
            type: "bytes32",
          },
          {
            internalType: "enum LibNativeOrder.OrderStatus",
            name: "status",
            type: "uint8",
          },
          {
            internalType: "uint128",
            name: "takerTokenFilledAmount",
            type: "uint128",
          },
        ],
        internalType: "struct LibNativeOrder.OrderInfo[]",
        name: "orderInfos",
        type: "tuple[]",
      },
      {
        internalType: "uint128[]",
        name: "actualFillableTakerTokenAmounts",
        type: "uint128[]",
      },
      {
        internalType: "bool[]",
        name: "isSignatureValids",
        type: "bool[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "contract IERC20TokenV06",
            name: "makerToken",
            type: "address",
          },
          {
            internalType: "contract IERC20TokenV06",
            name: "takerToken",
            type: "address",
          },
          {
            internalType: "uint128",
            name: "makerAmount",
            type: "uint128",
          },
          {
            internalType: "uint128",
            name: "takerAmount",
            type: "uint128",
          },
          {
            internalType: "uint128",
            name: "takerTokenFeeAmount",
            type: "uint128",
          },
          {
            internalType: "address",
            name: "maker",
            type: "address",
          },
          {
            internalType: "address",
            name: "taker",
            type: "address",
          },
          {
            internalType: "address",
            name: "sender",
            type: "address",
          },
          {
            internalType: "address",
            name: "feeRecipient",
            type: "address",
          },
          {
            internalType: "bytes32",
            name: "pool",
            type: "bytes32",
          },
          {
            internalType: "uint64",
            name: "expiry",
            type: "uint64",
          },
          {
            internalType: "uint256",
            name: "salt",
            type: "uint256",
          },
        ],
        internalType: "struct LibNativeOrder.LimitOrder",
        name: "order",
        type: "tuple",
      },
    ],
    name: "cancelLimitOrder",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IERC20TokenV06",
        name: "makerToken",
        type: "address",
      },
      {
        internalType: "contract IERC20TokenV06",
        name: "takerToken",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "minValidSalt",
        type: "uint256",
      },
    ],
    name: "cancelPairLimitOrders",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "maker",
        type: "address",
      },
      {
        internalType: "contract IERC20TokenV06",
        name: "makerToken",
        type: "address",
      },
      {
        internalType: "contract IERC20TokenV06",
        name: "takerToken",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "minValidSalt",
        type: "uint256",
      },
    ],
    name: "cancelPairLimitOrdersWithSigner",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IERC20TokenV06",
        name: "makerToken",
        type: "address",
      },
      {
        internalType: "contract IERC20TokenV06",
        name: "takerToken",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "minValidSalt",
        type: "uint256",
      },
    ],
    name: "cancelPairRfqOrders",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "maker",
        type: "address",
      },
      {
        internalType: "contract IERC20TokenV06",
        name: "makerToken",
        type: "address",
      },
      {
        internalType: "contract IERC20TokenV06",
        name: "takerToken",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "minValidSalt",
        type: "uint256",
      },
    ],
    name: "cancelPairRfqOrdersWithSigner",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "contract IERC20TokenV06",
            name: "makerToken",
            type: "address",
          },
          {
            internalType: "contract IERC20TokenV06",
            name: "takerToken",
            type: "address",
          },
          {
            internalType: "uint128",
            name: "makerAmount",
            type: "uint128",
          },
          {
            internalType: "uint128",
            name: "takerAmount",
            type: "uint128",
          },
          {
            internalType: "address",
            name: "maker",
            type: "address",
          },
          {
            internalType: "address",
            name: "taker",
            type: "address",
          },
          {
            internalType: "address",
            name: "txOrigin",
            type: "address",
          },
          {
            internalType: "bytes32",
            name: "pool",
            type: "bytes32",
          },
          {
            internalType: "uint64",
            name: "expiry",
            type: "uint64",
          },
          {
            internalType: "uint256",
            name: "salt",
            type: "uint256",
          },
        ],
        internalType: "struct LibNativeOrder.RfqOrder",
        name: "order",
        type: "tuple",
      },
    ],
    name: "cancelRfqOrder",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "contract IERC20TokenV06",
            name: "makerToken",
            type: "address",
          },
          {
            internalType: "contract IERC20TokenV06",
            name: "takerToken",
            type: "address",
          },
          {
            internalType: "uint128",
            name: "makerAmount",
            type: "uint128",
          },
          {
            internalType: "uint128",
            name: "takerAmount",
            type: "uint128",
          },
          {
            internalType: "uint128",
            name: "takerTokenFeeAmount",
            type: "uint128",
          },
          {
            internalType: "address",
            name: "maker",
            type: "address",
          },
          {
            internalType: "address",
            name: "taker",
            type: "address",
          },
          {
            internalType: "address",
            name: "sender",
            type: "address",
          },
          {
            internalType: "address",
            name: "feeRecipient",
            type: "address",
          },
          {
            internalType: "bytes32",
            name: "pool",
            type: "bytes32",
          },
          {
            internalType: "uint64",
            name: "expiry",
            type: "uint64",
          },
          {
            internalType: "uint256",
            name: "salt",
            type: "uint256",
          },
        ],
        internalType: "struct LibNativeOrder.LimitOrder",
        name: "order",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "enum LibSignature.SignatureType",
            name: "signatureType",
            type: "uint8",
          },
          {
            internalType: "uint8",
            name: "v",
            type: "uint8",
          },
          {
            internalType: "bytes32",
            name: "r",
            type: "bytes32",
          },
          {
            internalType: "bytes32",
            name: "s",
            type: "bytes32",
          },
        ],
        internalType: "struct LibSignature.Signature",
        name: "signature",
        type: "tuple",
      },
      {
        internalType: "uint128",
        name: "takerTokenFillAmount",
        type: "uint128",
      },
    ],
    name: "fillLimitOrder",
    outputs: [
      {
        internalType: "uint128",
        name: "takerTokenFilledAmount",
        type: "uint128",
      },
      {
        internalType: "uint128",
        name: "makerTokenFilledAmount",
        type: "uint128",
      },
    ],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "contract IERC20TokenV06",
            name: "makerToken",
            type: "address",
          },
          {
            internalType: "contract IERC20TokenV06",
            name: "takerToken",
            type: "address",
          },
          {
            internalType: "uint128",
            name: "makerAmount",
            type: "uint128",
          },
          {
            internalType: "uint128",
            name: "takerAmount",
            type: "uint128",
          },
          {
            internalType: "uint128",
            name: "takerTokenFeeAmount",
            type: "uint128",
          },
          {
            internalType: "address",
            name: "maker",
            type: "address",
          },
          {
            internalType: "address",
            name: "taker",
            type: "address",
          },
          {
            internalType: "address",
            name: "sender",
            type: "address",
          },
          {
            internalType: "address",
            name: "feeRecipient",
            type: "address",
          },
          {
            internalType: "bytes32",
            name: "pool",
            type: "bytes32",
          },
          {
            internalType: "uint64",
            name: "expiry",
            type: "uint64",
          },
          {
            internalType: "uint256",
            name: "salt",
            type: "uint256",
          },
        ],
        internalType: "struct LibNativeOrder.LimitOrder",
        name: "order",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "enum LibSignature.SignatureType",
            name: "signatureType",
            type: "uint8",
          },
          {
            internalType: "uint8",
            name: "v",
            type: "uint8",
          },
          {
            internalType: "bytes32",
            name: "r",
            type: "bytes32",
          },
          {
            internalType: "bytes32",
            name: "s",
            type: "bytes32",
          },
        ],
        internalType: "struct LibSignature.Signature",
        name: "signature",
        type: "tuple",
      },
      {
        internalType: "uint128",
        name: "takerTokenFillAmount",
        type: "uint128",
      },
    ],
    name: "fillOrKillLimitOrder",
    outputs: [
      {
        internalType: "uint128",
        name: "makerTokenFilledAmount",
        type: "uint128",
      },
    ],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "contract IERC20TokenV06",
            name: "makerToken",
            type: "address",
          },
          {
            internalType: "contract IERC20TokenV06",
            name: "takerToken",
            type: "address",
          },
          {
            internalType: "uint128",
            name: "makerAmount",
            type: "uint128",
          },
          {
            internalType: "uint128",
            name: "takerAmount",
            type: "uint128",
          },
          {
            internalType: "address",
            name: "maker",
            type: "address",
          },
          {
            internalType: "address",
            name: "taker",
            type: "address",
          },
          {
            internalType: "address",
            name: "txOrigin",
            type: "address",
          },
          {
            internalType: "bytes32",
            name: "pool",
            type: "bytes32",
          },
          {
            internalType: "uint64",
            name: "expiry",
            type: "uint64",
          },
          {
            internalType: "uint256",
            name: "salt",
            type: "uint256",
          },
        ],
        internalType: "struct LibNativeOrder.RfqOrder",
        name: "order",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "enum LibSignature.SignatureType",
            name: "signatureType",
            type: "uint8",
          },
          {
            internalType: "uint8",
            name: "v",
            type: "uint8",
          },
          {
            internalType: "bytes32",
            name: "r",
            type: "bytes32",
          },
          {
            internalType: "bytes32",
            name: "s",
            type: "bytes32",
          },
        ],
        internalType: "struct LibSignature.Signature",
        name: "signature",
        type: "tuple",
      },
      {
        internalType: "uint128",
        name: "takerTokenFillAmount",
        type: "uint128",
      },
    ],
    name: "fillOrKillRfqOrder",
    outputs: [
      {
        internalType: "uint128",
        name: "makerTokenFilledAmount",
        type: "uint128",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "contract IERC20TokenV06",
            name: "makerToken",
            type: "address",
          },
          {
            internalType: "contract IERC20TokenV06",
            name: "takerToken",
            type: "address",
          },
          {
            internalType: "uint128",
            name: "makerAmount",
            type: "uint128",
          },
          {
            internalType: "uint128",
            name: "takerAmount",
            type: "uint128",
          },
          {
            internalType: "address",
            name: "maker",
            type: "address",
          },
          {
            internalType: "address",
            name: "taker",
            type: "address",
          },
          {
            internalType: "address",
            name: "txOrigin",
            type: "address",
          },
          {
            internalType: "bytes32",
            name: "pool",
            type: "bytes32",
          },
          {
            internalType: "uint64",
            name: "expiry",
            type: "uint64",
          },
          {
            internalType: "uint256",
            name: "salt",
            type: "uint256",
          },
        ],
        internalType: "struct LibNativeOrder.RfqOrder",
        name: "order",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "enum LibSignature.SignatureType",
            name: "signatureType",
            type: "uint8",
          },
          {
            internalType: "uint8",
            name: "v",
            type: "uint8",
          },
          {
            internalType: "bytes32",
            name: "r",
            type: "bytes32",
          },
          {
            internalType: "bytes32",
            name: "s",
            type: "bytes32",
          },
        ],
        internalType: "struct LibSignature.Signature",
        name: "signature",
        type: "tuple",
      },
      {
        internalType: "uint128",
        name: "takerTokenFillAmount",
        type: "uint128",
      },
    ],
    name: "fillRfqOrder",
    outputs: [
      {
        internalType: "uint128",
        name: "takerTokenFilledAmount",
        type: "uint128",
      },
      {
        internalType: "uint128",
        name: "makerTokenFilledAmount",
        type: "uint128",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "contract IERC20TokenV06",
            name: "makerToken",
            type: "address",
          },
          {
            internalType: "contract IERC20TokenV06",
            name: "takerToken",
            type: "address",
          },
          {
            internalType: "uint128",
            name: "makerAmount",
            type: "uint128",
          },
          {
            internalType: "uint128",
            name: "takerAmount",
            type: "uint128",
          },
          {
            internalType: "uint128",
            name: "takerTokenFeeAmount",
            type: "uint128",
          },
          {
            internalType: "address",
            name: "maker",
            type: "address",
          },
          {
            internalType: "address",
            name: "taker",
            type: "address",
          },
          {
            internalType: "address",
            name: "sender",
            type: "address",
          },
          {
            internalType: "address",
            name: "feeRecipient",
            type: "address",
          },
          {
            internalType: "bytes32",
            name: "pool",
            type: "bytes32",
          },
          {
            internalType: "uint64",
            name: "expiry",
            type: "uint64",
          },
          {
            internalType: "uint256",
            name: "salt",
            type: "uint256",
          },
        ],
        internalType: "struct LibNativeOrder.LimitOrder",
        name: "order",
        type: "tuple",
      },
    ],
    name: "getLimitOrderHash",
    outputs: [
      {
        internalType: "bytes32",
        name: "orderHash",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "contract IERC20TokenV06",
            name: "makerToken",
            type: "address",
          },
          {
            internalType: "contract IERC20TokenV06",
            name: "takerToken",
            type: "address",
          },
          {
            internalType: "uint128",
            name: "makerAmount",
            type: "uint128",
          },
          {
            internalType: "uint128",
            name: "takerAmount",
            type: "uint128",
          },
          {
            internalType: "uint128",
            name: "takerTokenFeeAmount",
            type: "uint128",
          },
          {
            internalType: "address",
            name: "maker",
            type: "address",
          },
          {
            internalType: "address",
            name: "taker",
            type: "address",
          },
          {
            internalType: "address",
            name: "sender",
            type: "address",
          },
          {
            internalType: "address",
            name: "feeRecipient",
            type: "address",
          },
          {
            internalType: "bytes32",
            name: "pool",
            type: "bytes32",
          },
          {
            internalType: "uint64",
            name: "expiry",
            type: "uint64",
          },
          {
            internalType: "uint256",
            name: "salt",
            type: "uint256",
          },
        ],
        internalType: "struct LibNativeOrder.LimitOrder",
        name: "order",
        type: "tuple",
      },
    ],
    name: "getLimitOrderInfo",
    outputs: [
      {
        components: [
          {
            internalType: "bytes32",
            name: "orderHash",
            type: "bytes32",
          },
          {
            internalType: "enum LibNativeOrder.OrderStatus",
            name: "status",
            type: "uint8",
          },
          {
            internalType: "uint128",
            name: "takerTokenFilledAmount",
            type: "uint128",
          },
        ],
        internalType: "struct LibNativeOrder.OrderInfo",
        name: "orderInfo",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "contract IERC20TokenV06",
            name: "makerToken",
            type: "address",
          },
          {
            internalType: "contract IERC20TokenV06",
            name: "takerToken",
            type: "address",
          },
          {
            internalType: "uint128",
            name: "makerAmount",
            type: "uint128",
          },
          {
            internalType: "uint128",
            name: "takerAmount",
            type: "uint128",
          },
          {
            internalType: "uint128",
            name: "takerTokenFeeAmount",
            type: "uint128",
          },
          {
            internalType: "address",
            name: "maker",
            type: "address",
          },
          {
            internalType: "address",
            name: "taker",
            type: "address",
          },
          {
            internalType: "address",
            name: "sender",
            type: "address",
          },
          {
            internalType: "address",
            name: "feeRecipient",
            type: "address",
          },
          {
            internalType: "bytes32",
            name: "pool",
            type: "bytes32",
          },
          {
            internalType: "uint64",
            name: "expiry",
            type: "uint64",
          },
          {
            internalType: "uint256",
            name: "salt",
            type: "uint256",
          },
        ],
        internalType: "struct LibNativeOrder.LimitOrder",
        name: "order",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "enum LibSignature.SignatureType",
            name: "signatureType",
            type: "uint8",
          },
          {
            internalType: "uint8",
            name: "v",
            type: "uint8",
          },
          {
            internalType: "bytes32",
            name: "r",
            type: "bytes32",
          },
          {
            internalType: "bytes32",
            name: "s",
            type: "bytes32",
          },
        ],
        internalType: "struct LibSignature.Signature",
        name: "signature",
        type: "tuple",
      },
    ],
    name: "getLimitOrderRelevantState",
    outputs: [
      {
        components: [
          {
            internalType: "bytes32",
            name: "orderHash",
            type: "bytes32",
          },
          {
            internalType: "enum LibNativeOrder.OrderStatus",
            name: "status",
            type: "uint8",
          },
          {
            internalType: "uint128",
            name: "takerTokenFilledAmount",
            type: "uint128",
          },
        ],
        internalType: "struct LibNativeOrder.OrderInfo",
        name: "orderInfo",
        type: "tuple",
      },
      {
        internalType: "uint128",
        name: "actualFillableTakerTokenAmount",
        type: "uint128",
      },
      {
        internalType: "bool",
        name: "isSignatureValid",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getProtocolFeeMultiplier",
    outputs: [
      {
        internalType: "uint32",
        name: "multiplier",
        type: "uint32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "contract IERC20TokenV06",
            name: "makerToken",
            type: "address",
          },
          {
            internalType: "contract IERC20TokenV06",
            name: "takerToken",
            type: "address",
          },
          {
            internalType: "uint128",
            name: "makerAmount",
            type: "uint128",
          },
          {
            internalType: "uint128",
            name: "takerAmount",
            type: "uint128",
          },
          {
            internalType: "address",
            name: "maker",
            type: "address",
          },
          {
            internalType: "address",
            name: "taker",
            type: "address",
          },
          {
            internalType: "address",
            name: "txOrigin",
            type: "address",
          },
          {
            internalType: "bytes32",
            name: "pool",
            type: "bytes32",
          },
          {
            internalType: "uint64",
            name: "expiry",
            type: "uint64",
          },
          {
            internalType: "uint256",
            name: "salt",
            type: "uint256",
          },
        ],
        internalType: "struct LibNativeOrder.RfqOrder",
        name: "order",
        type: "tuple",
      },
    ],
    name: "getRfqOrderHash",
    outputs: [
      {
        internalType: "bytes32",
        name: "orderHash",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "contract IERC20TokenV06",
            name: "makerToken",
            type: "address",
          },
          {
            internalType: "contract IERC20TokenV06",
            name: "takerToken",
            type: "address",
          },
          {
            internalType: "uint128",
            name: "makerAmount",
            type: "uint128",
          },
          {
            internalType: "uint128",
            name: "takerAmount",
            type: "uint128",
          },
          {
            internalType: "address",
            name: "maker",
            type: "address",
          },
          {
            internalType: "address",
            name: "taker",
            type: "address",
          },
          {
            internalType: "address",
            name: "txOrigin",
            type: "address",
          },
          {
            internalType: "bytes32",
            name: "pool",
            type: "bytes32",
          },
          {
            internalType: "uint64",
            name: "expiry",
            type: "uint64",
          },
          {
            internalType: "uint256",
            name: "salt",
            type: "uint256",
          },
        ],
        internalType: "struct LibNativeOrder.RfqOrder",
        name: "order",
        type: "tuple",
      },
    ],
    name: "getRfqOrderInfo",
    outputs: [
      {
        components: [
          {
            internalType: "bytes32",
            name: "orderHash",
            type: "bytes32",
          },
          {
            internalType: "enum LibNativeOrder.OrderStatus",
            name: "status",
            type: "uint8",
          },
          {
            internalType: "uint128",
            name: "takerTokenFilledAmount",
            type: "uint128",
          },
        ],
        internalType: "struct LibNativeOrder.OrderInfo",
        name: "orderInfo",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "contract IERC20TokenV06",
            name: "makerToken",
            type: "address",
          },
          {
            internalType: "contract IERC20TokenV06",
            name: "takerToken",
            type: "address",
          },
          {
            internalType: "uint128",
            name: "makerAmount",
            type: "uint128",
          },
          {
            internalType: "uint128",
            name: "takerAmount",
            type: "uint128",
          },
          {
            internalType: "address",
            name: "maker",
            type: "address",
          },
          {
            internalType: "address",
            name: "taker",
            type: "address",
          },
          {
            internalType: "address",
            name: "txOrigin",
            type: "address",
          },
          {
            internalType: "bytes32",
            name: "pool",
            type: "bytes32",
          },
          {
            internalType: "uint64",
            name: "expiry",
            type: "uint64",
          },
          {
            internalType: "uint256",
            name: "salt",
            type: "uint256",
          },
        ],
        internalType: "struct LibNativeOrder.RfqOrder",
        name: "order",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "enum LibSignature.SignatureType",
            name: "signatureType",
            type: "uint8",
          },
          {
            internalType: "uint8",
            name: "v",
            type: "uint8",
          },
          {
            internalType: "bytes32",
            name: "r",
            type: "bytes32",
          },
          {
            internalType: "bytes32",
            name: "s",
            type: "bytes32",
          },
        ],
        internalType: "struct LibSignature.Signature",
        name: "signature",
        type: "tuple",
      },
    ],
    name: "getRfqOrderRelevantState",
    outputs: [
      {
        components: [
          {
            internalType: "bytes32",
            name: "orderHash",
            type: "bytes32",
          },
          {
            internalType: "enum LibNativeOrder.OrderStatus",
            name: "status",
            type: "uint8",
          },
          {
            internalType: "uint128",
            name: "takerTokenFilledAmount",
            type: "uint128",
          },
        ],
        internalType: "struct LibNativeOrder.OrderInfo",
        name: "orderInfo",
        type: "tuple",
      },
      {
        internalType: "uint128",
        name: "actualFillableTakerTokenAmount",
        type: "uint128",
      },
      {
        internalType: "bool",
        name: "isSignatureValid",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "maker",
        type: "address",
      },
      {
        internalType: "address",
        name: "signer",
        type: "address",
      },
    ],
    name: "isValidOrderSigner",
    outputs: [
      {
        internalType: "bool",
        name: "isValid",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "migrate",
    outputs: [
      {
        internalType: "bytes4",
        name: "success",
        type: "bytes4",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "signer",
        type: "address",
      },
      {
        internalType: "bool",
        name: "allowed",
        type: "bool",
      },
    ],
    name: "registerAllowedOrderSigner",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "origins",
        type: "address[]",
      },
      {
        internalType: "bool",
        name: "allowed",
        type: "bool",
      },
    ],
    name: "registerAllowedRfqOrigins",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32[]",
        name: "poolIds",
        type: "bytes32[]",
      },
    ],
    name: "transferProtocolFeesForPools",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

export class NativeOrdersFeature__factory extends ContractFactory {
  constructor(
    ...args: [signer: Signer] | ConstructorParameters<typeof ContractFactory>
  ) {
    if (args.length === 1) {
      super(_abi, _bytecode, args[0]);
    } else {
      super(...args);
    }
  }

  deploy(
    zeroExAddress: string,
    weth: string,
    staking: string,
    feeCollectorController: string,
    protocolFeeMultiplier: BigNumberish,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<NativeOrdersFeature> {
    return super.deploy(
      zeroExAddress,
      weth,
      staking,
      feeCollectorController,
      protocolFeeMultiplier,
      overrides || {}
    ) as Promise<NativeOrdersFeature>;
  }
  getDeployTransaction(
    zeroExAddress: string,
    weth: string,
    staking: string,
    feeCollectorController: string,
    protocolFeeMultiplier: BigNumberish,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      zeroExAddress,
      weth,
      staking,
      feeCollectorController,
      protocolFeeMultiplier,
      overrides || {}
    );
  }
  attach(address: string): NativeOrdersFeature {
    return super.attach(address) as NativeOrdersFeature;
  }
  connect(signer: Signer): NativeOrdersFeature__factory {
    return super.connect(signer) as NativeOrdersFeature__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): NativeOrdersFeatureInterface {
    return new utils.Interface(_abi) as NativeOrdersFeatureInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): NativeOrdersFeature {
    return new Contract(address, _abi, signerOrProvider) as NativeOrdersFeature;
  }
}
